import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class EisaScoringRoute extends Route
{
	@service ajax

	resultsTimer = null
	configTimer = null

	resultsRefreshInterval = 10000
	configRefreshInterval = 60000

	async model()
	{
		const config = await this.fetchConfig();
		const results = await this.fetchAllResults(config);
		return { config, results };
	}

	setupController(controller, model)
	{
		controller.set('event', this.modelFor('event'));
		controller.set('config', model.config);
		controller.set('results', model.results);
	}

	async fetchConfig()
	{
		return await this.ajax.request("eisaScoringConfig.json");
	}

	async fetchAllResults(config = null)
	{
		if (config == null)
		{
			if (this.controller == undefined)
			{
				return {};
			}
			config = this.controller.config;
		}

		// Collect unique results files from all races
		const filesToFetch = new Set();
		for (const race of config?.nordic?.races || [])
		{
			filesToFetch.add(race.resultsFile);
		}
		// Future: add alpine races here

		const results = {};
		for (const fileName of filesToFetch)
		{
			let data = await this.ajax.request(fileName);
			data = data.map(r => r.data.attributes);
			results[fileName] = data;
		}
		return results;
	}

	async fetchResultsLoop()
	{
		cancel(this.resultsTimer);
		this.resultsTimer = later(this, async function()
		{
			const results = await this.fetchAllResults();
			this.controller.set('results', results);

			this.fetchResultsLoop();
		}, this.resultsRefreshInterval);
	}

	async fetchConfigLoop()
	{
		cancel(this.configTimer);
		this.configTimer = later(this, async function()
		{
			const config = await this.fetchConfig();
			this.controller.set('config', config);

			this.fetchConfigLoop();
		}, this.configRefreshInterval);
	}

	activate(transition)
	{
		this.fetchResultsLoop();
		this.fetchConfigLoop();
	}

	deactivate(transition)
	{
		cancel(this.resultsTimer);
		cancel(this.configTimer);
	}
}
